import React from 'react';

const RateStarIcon = () => (
  <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5182 4.09508L18.5716 8.20175C18.8516 8.77341 19.5982 9.32175 20.2282 9.42675L23.9499 10.0451C26.3299 10.4417 26.8899 12.1684 25.1749 13.8717L22.2816 16.7651C21.7916 17.2551 21.5232 18.2001 21.6749 18.8767L22.5032 22.4584C23.1566 25.2934 21.6516 26.3901 19.1432 24.9084L15.6549 22.8434C15.0249 22.4701 13.9866 22.4701 13.3449 22.8434L9.85656 24.9084C7.35989 26.3901 5.84323 25.2817 6.49656 22.4584L7.32489 18.8767C7.47656 18.2001 7.20823 17.2551 6.71823 16.7651L3.82489 13.8717C2.12156 12.1684 2.66989 10.4417 5.04989 10.0451L8.77156 9.42675C9.38989 9.32175 10.1366 8.77341 10.4166 8.20175L12.4699 4.09508C13.5899 1.86674 15.4099 1.86674 16.5182 4.09508Z"
      fill="currentColor"
    />
  </svg>
);

export default RateStarIcon;
